import { useDialogs } from '../../model/providers';

export const useDeleteOrganization = () => {
  const { dialogConfig } = useDialogs()!;

  return dialogConfig;
};
